import "components/shared/FormComponent/style.scss";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

type ShowDefaultConfigurationFieldProps = {
    checked: boolean;
    onChange: (showDefaultConfiguration: boolean) => void;
};

/**
 * Typology only. Same Oui/Non radio as the other typology settings.
 * Chooses whether the contract form shows this channel's default formula.
 */
const ShowDefaultConfigurationField = ({ checked, onChange }: ShowDefaultConfigurationFieldProps) => {
    const [t] = useTranslation();

    return (
        <div className="form-component channel-show-default">
            <label className="form-component-label">{t("ConnectTitle.ShowDefaultConfiguration")}</label>
            <span className="label-description">{t("ConnectTitle.ShowDefaultConfigurationHint")}</span>
            <RadioGroup row value={checked ? "1" : "0"} onChange={(event) => onChange(event.target.value === "1")}>
                <FormControlLabel
                    value="0"
                    control={<Radio checkedIcon={<CheckCircleIcon />} />}
                    label={t("ConnectTitle.No")}
                />
                <FormControlLabel
                    value="1"
                    control={<Radio checkedIcon={<CheckCircleIcon />} />}
                    label={t("ConnectTitle.Yes")}
                />
            </RadioGroup>
        </div>
    );
};

export default ShowDefaultConfigurationField;
